export default {
  auth: () => import("/app/apps/admin/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/app/apps/admin/layouts/default.vue").then(m => m.default || m),
  publish: () => import("/app/apps/admin/layouts/publish.vue").then(m => m.default || m)
}